
export { colors } from "/vercel/path0/packages/fitify-ui/src/theme/colors.ts"